export const ES_PRIVACY_LINK: string = 'https://oportun.com/es/privacy';
export const EN_PRIVACY_LINK: string = 'https://oportun.com/privacy';
export const ES_ESIGN_LINK: string = 'https://oportun.com/es/esign';
export const EN_ESIGN_LINK: string = 'https://oportun.com/esign';
export const EN_FAQ_LINK: string = 'https://oportun.com/faq';
export const ES_FAQ_LINK: string = 'https://oportun.com/es/faq';
